import Component from "@glimmer/component"
import styles from "./expand-collapse-button.module.css"

export default class PlannerCardStacksLessonExpandCollapseButtonComponent extends Component {
  readonly styles = styles
}
